<template>
  <Card :title="$t('common.A/B Element')">
    <CardSection>
      <FormLayout>
        <BaseNodeProperties
          :node="node"
          :readonly="readonly"
        />
        <TextField
          :label="$t('common.Percent')"
          :help-text="$t('help.trafficPercentage')"
          :disabled="readonly"
          suffix="%"
          v-model="node.percent"
        />
      </FormLayout>
    </CardSection>
  </Card>
</template>

<script>
import mixin from './propertiesMixin'

export default {
  mixins: [mixin]
}
</script>
